<template>
  <modal-add
    :title="'Add Paid Item'"
    @close="closeModal"
  >
    <form>
      <div class="form-row">
        <div class="form-group text-note">
          <label for="item-description">Cart Item Type</label>
          <select class="form-control"
                  v-model="selectedCartItemIdx">
            <option v-for="(option, index) in cartItems" :key="index"
                    v-text="option.name" :value="index"></option>
          </select>
        </div>
      </div>
      <div class="form-row" v-if="cartItem && !cartItem.pre_def">
        <div class="form-group text-note">
          <label for="item-description-text">Item Description</label>
          <input type="text" v-model="description" class="form-control" id="item-description-text">
        </div>
      </div>
      <div class="form-row" v-if="cartItem && cartItem.pre_def">
        <div class="form-group text-note">
          <label for="item-description-dropdown">Cart Item Type</label>
          <select class="form-control"
                  id="item-description-dropdown"
                  v-model="selectedPreDef">
            <option v-for="(option, index) in cartItem.pre_def" :key="index"
                    v-text="option.name" :value="option"></option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group position-relative text-note" v-if="!cartItem || cartItem && !cartItem.hasOwnProperty('options')">
          <label for="item-price">Price</label>
          <input type="number" min="0" v-model="price"
                 :disabled="cartItem && cartItem.pre_def"
                 placeholder="0" class="form-control" id="item-price">
          <span class="dollar-sign-prepend">$</span>
        </div>
        <div class="form-group position-relative text-note" v-else>
          <label for="cart-item-options">Please Select</label>
          <select class="form-control"
                  id="cart-item-options"
                  v-model="price">
            <option v-for="(option, index) in cartItem.options" :key="index"
                    v-text="option" :value="index"></option>
          </select>
        </div>
      </div>
      <div class="form-row" v-if="cartItem && cartItem.hasOwnProperty('creditcards')">
        <div class="form-group text-note">
          <label for="item-creditcard-dropdown">Please select CreditCard</label>
          <select class="form-control"
                  id="item-creditcard-dropdown"
                  v-model="creditCardSelected">
            <option v-for="(cardNum, id) in cartItem.creditcards" :key="id"
                    v-text="cardNum" :value="id"></option>
          </select>
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-between mt-5">
      <button @click="closeModal" class="btn-dialog">
        Cancel
      </button>
      <button class="btn-dialog ok-btn"  @click="saveItem"
              :disabled="!description || !price || !cartItem">Ok</button>
    </div>
  </modal-add>
</template>

<script>
import DibbleApi from "../../../api";
import DibbleJS from "../../../dibble";
import ModalAdd from "@/components/RentalInfo/Modal/AddOption";

export default {
  name: "ModalAddPayItemV2",
  components: {ModalAdd},
  props: {
    orderId: {
      required: true,
      type: String
    },
    cartItems: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedCartItemIdx: 0,
      cartItem: null,
      selectedPreDef: null,
      description: "",
      price: "",
      creditCardSelected: null
    };
  },
  watch: {
    selectedCartItemIdx(index) {
      this.cartItem = this.cartItems[index]
      this.description = ''
      this.price = ''
      this.selectedPreDef = null
      this.creditCardSelected = null
    },
    selectedPreDef(val) {
      if (val) {
        this.price = val.price
        this.description = val.name
      }
    }
  },
  created() {
  },
  methods: {
    resetElements() {
      this.cartItem = null
      this.selectedCartItemIdx = 0
      this.description = ''
      this.price = ''
      this.selectedPreDef = null
    },
    closeModal() {
      this.cartItem = null
      this.description = "";
      this.price = 0;
      this.$emit("close");
    },
    saveItem() {
      const params = {
        request: DibbleApi.api.addRentalBoatPayedItem,
        order_id: this.orderId,
        item_description: this.description,
        price: this.price,
        cart_item_type: this.selectedCartItemIdx
      };

      if (this.creditCardSelected) {
        params.creditcard_id = this.creditCardSelected;
      }

      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, response => {
        DibbleJS.hideLoader();
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message);
          this.description = "";
          this.price = 0;
          this.$emit("saved");
        } else {
          DibbleJS.toastErrorMessage(response.message);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.btn-pay {
  font-weight: 600;
  font-size: 20px;
  line-height: 18px;
  color: #ffffff;
  background: #1c5169;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  padding: 20px 20px;
  border: none;
  font-family: "Open Sans";
  font-style: normal;
}

// dialog
.text-note {
  width: 100%;
  background: #e8eff1 !important;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #7c7c7a;
  padding: 20px;
  border: none;
}

.select-credit {
  width: 100%;
  background: #e8eff1 !important;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #7c7c7a;
  padding: 10px 20px 50px;

  &:nth-child(2) {
    padding: 20px !important;
  }

  border: none;

  .text-credit {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.01em;
    color: #7c7c7a;
    margin: 0;
  }

  .title-credit-card {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.01em;
    color: #555e67;
  }
}

.btn-dialog {
  width: 180px;
  height: 60px;
  background: #d9d9d9;
  box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 18px;
  text-align: space-between;
  color: #ffffff;
  border: none;
}

.ok-btn {
  background: #2178ab;
  color: #ffffff;
}

// checkbox
.checkbox-custom {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-custom input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  border: none;
}

/* Create a custom checkbox */
.checkmark-new {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #2c94ab;
  border: none !important;
  border-radius: 9px;
}

/* When the checkbox is checked, add a blue background */
.checkbox-custom input:checked ~ .checkmark-new {
  background-color: #2c94ab;
}

/* Show the checkmark when checked */
.checkbox-custom input:checked ~ .checkmark-new:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-custom .checkmark-new:after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(40deg);
  -ms-transform: rotate(40deg);
  transform: rotate(40deg);
}
</style>
